import { jsx } from "react/jsx-runtime";
import { formatDate, formatDateTime, formatRelative } from "@batiflow/i18n";
import { __css, mergeClasses } from "@fluentui/react-components";
import { useLocale } from "../internal/use-locale.js";
const useStyles = __css({"root":{"B7salou":"f1pbl6dw","Huce71":"fz5stix"}});
function DateText({ value, variant = "date", now, className }) {
  const locale = useLocale();
  const styles = useStyles();
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const full = formatDateTime(date, locale);
  const text = variant === "date" ? formatDate(date, locale) : variant === "dateTime" ? full : formatRelative(date, now ?? /* @__PURE__ */ new Date(), locale);
  return /* @__PURE__ */ jsx(
    "time",
    {
      dateTime: date.toISOString(),
      title: full,
      className: mergeClasses(styles.root, className),
      children: /* @__PURE__ */ jsx("bdi", { children: text })
    }
  );
}
export {
  DateText
};
//# sourceMappingURL=date-text.js.map

import "/opt/batiflow/app/packages/ui/dist/components/date-text/date-text.griffel.css";